import { ContentfulClientApi } from 'contentful'
import questionsConfig from '../config/.questions'
import solutionsConfig from '../config/.solutions'
const contentful = require('contentful')

export const questions: ContentfulClientApi = contentful.createClient({ ...questionsConfig })
export const solutions: ContentfulClientApi = contentful.createClient({ ...solutionsConfig })
